import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import Thank from '../components/Thankyou.vue'

Vue.use(Router)

 
export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home 
    },{
      path: '/gracias',
      name: 'thank',
      component: Thank 
  }
  ]
})

